import React, { memo, useState } from "react";
import styles from "./CommonCheckBox.module.scss";
import { CheckedIcon } from "../../../assets/icons";
import path from "path";

type Props = {
	title?: string;
	selected?: boolean;
	isVisible?: boolean;
	isAssigned?: boolean;
	onToggle?: () => void;
	className?: string;
	color?: string;
	followState?: boolean;
};

const CommonCheckBox: React.FC<Props> = memo((props: Props) => {
	const { isVisible = true } = props;
	const [isSelected, setIsSelected] = useState(props.selected);
	const color = props.color || "#2E3336";
	const onToggleHandler = () => {
		if (props.onToggle != null) props.onToggle();
		setIsSelected(prev => !prev);
	};
	return (
		<button type="button" role="checkbox" className={`${styles.item} ${props?.className} ${isVisible ? "" : styles.isNotVisible}`} onClick={onToggleHandler}>
			<div className={`${styles.checkBox} checkbox`} style={{ fill: color, border: `1px solid ${color}` }}>
				{(props?.selected || (props.followState == null && isSelected)) && <CheckedIcon className={`${color === "black" ? styles.black : ""}`} />}
			</div>
			{props.title}
			{props.isAssigned && (
				<div className={styles.assigned}>
					<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M5.45851 7.45593L12.4313 0.483117C12.6213 0.293201 12.8466 0.198242 13.1073 0.198242C13.368 0.198242 13.5933 0.293201 13.7832 0.483117C13.9732 0.673034 14.0681 0.898353 14.0681 1.15908C14.0681 1.41978 13.9732 1.6451 13.7832 1.83501L6.12653 9.49172C5.93661 9.68164 5.71394 9.7766 5.45851 9.7766C5.20308 9.7766 4.98041 9.68164 4.79049 9.49172L1.21711 5.91835C1.0272 5.72843 0.934878 5.50312 0.940155 5.24241C0.945447 4.98169 1.04305 4.75637 1.23297 4.56645C1.42288 4.37653 1.6482 4.28158 1.90893 4.28158C2.16963 4.28158 2.39495 4.37653 2.58486 4.56645L5.45851 7.45593Z"
							fill={color}
						/>
					</svg>
					Assigned
				</div>
			)}
		</button>
	);
});

export default CommonCheckBox;
